/**
 * Recently-viewed sheets — muscle-memory plan-room navigation.
 *
 * Stores up to 8 recently-opened sheets in localStorage so a superintendent
 * can flip between the last few sheets they touched in <100ms without going
 * back to the portfolio. Keyed by sheet_id; deduped on every push.
 */

const KEY = "fop_recent_sheets";
const MAX = 8;

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function write(list) {
  try { localStorage.setItem(KEY, JSON.stringify(list)); } catch {}
}

export function pushRecentSheet(entry) {
  if (!entry || !entry.id) return;
  const existing = read().filter((s) => s.id !== entry.id);
  const next = [
    {
      id: entry.id,
      sheet_number: entry.sheet_number,
      sheet_title: entry.sheet_title,
      project_id: entry.project_id,
      viewed_at: new Date().toISOString(),
    },
    ...existing,
  ].slice(0, MAX);
  write(next);
}

export function getRecentSheets(excludeId = null) {
  return read().filter((s) => s.id !== excludeId);
}

export function clearRecentSheets() {
  try { localStorage.removeItem(KEY); } catch {}
}
